var _excluded = ["children", "autoComplete"];
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { Form as FormSemantic } from 'semantic-ui-react';
import { FormButton, FormCheckbox, FormDropdown, FormGroup, FormInput, FormRadio, FormSelect, FormTextArea } from "../..";
import FormField from "./FormField";
import * as SUI from "../../utils/SUI";

/**
 * A Form displays a set of related user input fields in a structured way.
 *
 * @param {*} props
 */
import { jsx as _jsx } from "react/jsx-runtime";
var Form = function Form(props) {
  var children = props.children,
    autoComplete = props.autoComplete,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  if (!autoComplete) {
    return /*#__PURE__*/_jsx(FormSemantic, Object.assign({
      autoComplete: "off"
    }, rest, {
      children: children
    }));
  }
  return /*#__PURE__*/_jsx(FormSemantic, Object.assign({}, rest, {
    children: children
  }));
};
Form.handledProps = ["action", "as", "autoComplete", "children", "className", "error", "inverted", "loading", "onSubmit", "reply", "size", "success", "unstackable", "warning", "widths"];
Form.propTypes = {
  /** An element type to render as (string or function). */
  as: PropTypes.oneOfType([PropTypes.func, PropTypes.string, PropTypes.symbol]),
  /** The HTML form action */
  action: PropTypes.string,
  /** Primary content. */
  children: PropTypes.node,
  /** Additional classes. */
  className: PropTypes.string,
  /** Automatically show any error Message children. */
  error: PropTypes.bool,
  /** A form can have its color inverted for contrast. */
  inverted: PropTypes.bool,
  /** Automatically show a loading indicator. */
  loading: PropTypes.bool,
  /** The HTML form submit handler. */
  onSubmit: PropTypes.func,
  /** A comment can contain a form to reply to a comment. This may have arbitrary content. */
  reply: PropTypes.bool,
  /** A form can vary in size. */
  size: PropTypes.oneOf(_.without(SUI.SIZES, 'medium')),
  /** Automatically show any success Message children. */
  success: PropTypes.bool,
  /** A form can prevent itself from stacking on mobile. */
  unstackable: PropTypes.bool,
  /** Automatically show any warning Message children. */
  warning: PropTypes.bool,
  /** Forms can automatically divide fields to be equal width. */
  widths: PropTypes.oneOf(['equal']),
  /** Auto complete. */
  autoComplete: PropTypes.bool
};
Form.defaultProps = {
  as: 'form',
  autoComplete: false
};
Form.Field = FormField;
Form.Button = FormButton;
Form.Checkbox = FormCheckbox;
Form.Dropdown = FormDropdown;
Form.Group = FormGroup;
Form.Input = FormInput;
Form.Radio = FormRadio;
Form.Select = FormSelect;
Form.TextArea = FormTextArea;
export default Form;